import * as z from "zod";

/** Element id -> field -> text. English and localization-off return {}. */
export const getPortalCustomizationTextOverlay = {
  name: "getPortalCustomizationTextOverlay" as const,
  input: z.object({ language: z.string().max(35) }),
  output: z.object({
    overlay: z.record(z.string(), z.record(z.string(), z.string())),
  }),
};
